import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class RotatingGradientModule {
    static init(el){
        const rotatingGradient = el.detail.element.querySelector('[data-rotating-gradient]');
        new RotatingGradientModule(rotatingGradient);
    }

    constructor(rotatingGradient) {
        if(!rotatingGradient) {
            return;
        }

        this.wrapper = rotatingGradient;
        this.gradient = rotatingGradient.querySelector('.bg-gradient-orange__inner');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.wrapper,
                start: "top center",
                scrub: false,
            }
        });
        tl.fromTo(this.gradient, {
            rotation: -230,
            scale: 3
        }, {
            rotation: 0,
            scale: 1,
            duration: 3
        });

    }
}
